import React, { Fragment } from "react";

// External Components
import Modal from "react-bootstrap/Modal";

// Icons
import CloseIcon from "../../../../assets/icons/close.svg";
import filePDF from "../../../../assets/icons/file-pdf-24.svg";

// Stylesheets
import "./DocumentPreview.scss";

// Custom Components
import PDFViewer from "../../../PDFViewer/PDFViewer";
import { sort } from "fast-sort";
import { useMutation } from "@apollo/client";
import { GET_PRESIGNED_URL } from "../DocumentStatus/DocumentStatus";
import { notify } from "../../../Notify/Notify";
import UseAnimations from "react-useanimations";
import loadingIcon from "react-useanimations/lib/loading2";

function DocumentPreview({
  isOpen,
  onClose,
  fileInfo = {},
  mergedDocuments = [],
  previewFileHandler = () => {},
}) {
  const isFromMarge = fileInfo?.isFromMarge ?? true;
  const primaryDocs = mergedDocuments.find((doc) => doc?.isPrimary) ?? {};
  const [getPresignedUrl, { loading }] = useMutation(GET_PRESIGNED_URL);

  return (
    <Fragment>
      <Modal
        size="xl"
        centered
        show={isOpen}
        className="new-design-v1 document-preview-container"
      >
        <Modal.Header>
          <h4 className="modal-title">{fileInfo.title ?? ""}</h4>
          <img
            className="close"
            src={CloseIcon}
            alt="closeIcon"
            onClick={onClose}
          />
        </Modal.Header>
        <Modal.Body className="document-previewer-body">
          <div className="px-8">
            <div>
              <div className="document-view-files-title">Primary File</div>
              <div
                style={{ cursor: "pointer" }}
                onClick={async () => {
                  try {
                    if (loading || !isFromMarge) {
                      return;
                    }
                    const data = await getPresignedUrl({
                      variables: {
                        documentRequestSubmissionId: primaryDocs?.id,
                      },
                    });
                    const url = data?.data?.data?.url;
                    if (url) {
                      previewFileHandler({
                        documentId: primaryDocs?.id,
                        title: primaryDocs?.documentName,
                        url,
                      });
                    }
                  } catch (error) {
                    notify("Error", "Something went wrong.", "error");
                  }
                }}
              >
                <FileCard
                  isActive={
                    isFromMarge
                      ? primaryDocs?.id === fileInfo?.documentId
                      : true
                  }
                  fileName={
                    isFromMarge ? primaryDocs?.documentName : fileInfo?.title
                  }
                />
              </div>
            </div>
            {isFromMarge && (
              <div className="mt-6">
                <div className="document-view-files-title">Sub-Files</div>
                {sort(mergedDocuments?.filter((docs) => !docs?.isPrimary))
                  .asc((u) => u?.documentName?.toLowerCase())
                  .map((docs) => (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={async () => {
                        try {
                          if (loading) {
                            return;
                          }
                          const data = await getPresignedUrl({
                            variables: {
                              documentRequestSubmissionId: docs?.id,
                            },
                          });
                          const url = data?.data?.data?.url;
                          if (url) {
                            previewFileHandler({
                              documentId: docs?.id,
                              title: docs?.documentName,
                              url,
                            });
                          }
                        } catch (error) {
                          notify("Error", "Something went wrong.", "error");
                        }
                      }}
                    >
                      <FileCard
                        isActive={docs?.id === fileInfo?.documentId}
                        fileName={docs?.documentName}
                      />
                    </div>
                  ))}
              </div>
            )}
          </div>
          <div>
            <PDFViewer pdfFile={fileInfo?.url ?? ""} />
            {loading && (
              <div className="loading-wrapper">
                <UseAnimations
                  className="loading-icon"
                  animation={loadingIcon}
                  autoplay={true}
                  loop={true}
                  strokeColor="Blue"
                  size={40}
                />
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="px-8">
          <button
            className="new-design-v1 secondary-button"
            style={{ maxWidth: "80px", maxHeight: "40px" }}
            onClick={onClose}
          >
            Exit{" "}
          </button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
}

export default DocumentPreview;

function FileCard({ isActive = false, fileName = "" }) {
  const truncatedFileName =
    fileName.length > 26 ? fileName.substring(0, 24) + "..." : fileName;
  return (
    <div
      className={[
        "pl-6 mt-3 uploaded-file d-flex align-items-center",
        isActive ? "active-doc" : "",
      ].join(" ")}
    >
      <div className="d-flex">
        <div className="uploaded-file-icon">
          <img src={filePDF} alt="pdf" />
        </div>
        <div className="ml-2 uploaded-file-title overflow-hidden">
          {truncatedFileName}
        </div>
      </div>
    </div>
  );
}
